export const pkgSelectedData = {
  data: [],
  lastSelectedData: {},
}

export const selectedDataGetters = {
  selectedDataLength: (state) => state.selectedData.data.length,
  selectedDataType: (state) => state.selectedData.type,
  selectedNeids: (state) => state.selectedData.data.map((item) => item.data.neid),
  pkgSelectedLength: (state) => state.pkgSelectedData.data.length,
  pkgLastSelectedData: (state) => state.pkgSelectedData.lastSelectedData,
}

export const selectedDataMutations = {
  addPkgData(state, obj) {
    const { data } = state.pkgSelectedData
    for (let i = 0; i < data.length; i += 1) {
      if (data[i].index === obj.index) {
        data[i] = obj
        return
      }
    }
    state.pkgSelectedData.data.push(obj)
  },
  setLastSelectedData(state, lastSelectedData) {
    state.pkgSelectedData.lastSelectedData = lastSelectedData
  },
  delPkgData(state, index) {
    const { data } = state.pkgSelectedData
    for (let i = 0; i < data.length; i += 1) {
      if (data[i].index === index) {
        data.splice(i, 1)
      }
    }
  },
  clearPkgData(state) {
    state.pkgSelectedData.data.splice(0, state.pkgSelectedData.data.length)
    state.pkgSelectedData.lastSelectedData = {}
  },
  updateSelectedData(state, data) {
    state.selectedData.data = [data]
  },
}
